import { render, staticRenderFns } from "./basket.vue?vue&type=template&id=4e8cd130&scoped=true"
import script from "./basket.vue?vue&type=script&lang=js"
export * from "./basket.vue?vue&type=script&lang=js"
import style0 from "./basket.vue?vue&type=style&index=0&id=4e8cd130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8cd130",
  null
  
)

export default component.exports